<template>
  <MenuWrapper class="mx-2 mt-8">
    <template v-for="(route, index) in menuItems" :key="index">
      <MenuLink
        v-if="canView(route)"
        :href="getHref(route?.meta?.href)"
        :newTab="route.meta?.newTab"
        :icon="route.meta?.icon"
        :to="!route.meta?.href && route.name ? { name: route.name } : undefined"
        :title="route.meta?.title || route.name"
        :hoverableTitle="!props.isExpanded"
        :dot-type="route.meta?.badge"
      >
        {{ route.meta?.title }}
        <NewBadge v-if="route.meta?.badge === 'new'" class="inline-badge" size="regular" />
        <BetaBadge v-if="route.meta?.badge === 'beta'" class="inline-badge" size="regular" />
      </MenuLink>
    </template>
  </MenuWrapper>
</template>
<script setup lang="ts">
import { MenuWrapper, MenuLink } from '@/storybook/menu';
import { NewBadge, BetaBadge } from '@/storybook';
import { useRouter, RouteRecordRaw } from 'vue-router';
import { SIDEBAR_TYPES } from '@/router';

interface RouteMeta {
  href?: string;
  icon?: string;
  title?: string;
  newTab?: boolean;
  badge?: string;
  visible?: boolean | (() => boolean);
}

type CustomRoute = RouteRecordRaw & {
  name: string;
  meta?: RouteMeta;
};

const props = defineProps<{
  isExpanded: boolean;
  type: SIDEBAR_TYPES;
}>();

const routes = useRouter().getRoutes();
const menuItems = routes.find(c => c.name === props.type)?.children as CustomRoute[] | undefined;

const canView = (route: CustomRoute) => {
  if (route.meta?.visible === false) {
    return false;
  }

  if (typeof route.meta?.visible === 'function') {
    return route.meta.visible();
  }

  return true;
};

const getHref = (href: string | (() => string) | undefined): string => {
  if (!href) {
    return '';
  }

  if (typeof href === 'function') {
    return href();
  }

  return href?.trim();
};
</script>

<style scoped>
.inline-badge {
  line-height: 1;
  padding: 0.125rem 0.25rem !important;
}
</style>
